import { render } from "./WegowAdsCard.vue?vue&type=template&id=3564fd04&scoped=true"
import script from "./WegowAdsCard.vue?vue&type=script&lang=js"
export * from "./WegowAdsCard.vue?vue&type=script&lang=js"

import "./WegowAdsCard.vue?vue&type=style&index=0&id=3564fd04&scoped=true&lang=scss"
import "./WegowAdsCard.vue?vue&type=style&index=1&id=3564fd04&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3564fd04"]])

export default __exports__